// import third-party
import React from 'react';
import { Box, Input, Button, Text, Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';

// import third-party
import { EditIcon2, MoreIcon, TrashcanIcon } from '@assets/icons';
import { useBundleStore } from '@pages/UploadMappingV2/hooks/state/useAddProductBundle';

function BundleNameCell() {
    const { bundle, setName, errors } = useBundleStore();

    return (
        <Box>
            <Input
                placeholder="Tuliskan nama dari Bundle produk"
                value={bundle.name ?? ''}
                onChange={(e) => setName(e.target.value)}
                isInvalid={errors.name}
            />
            <Text fontSize={'10px'} mt={'4px'} color={'danger.500'}>
                {errors.name}
            </Text>
        </Box>
    );
}

function CodeCell() {
    const { bundle, setCode, errors } = useBundleStore();

    return (
        <Box>
            <Input
                placeholder="Tuliskan kode produk"
                value={bundle.code ?? ''}
                onChange={(e) => setCode(e.target.value)}
                isInvalid={errors.code}
            />
            <Text fontSize={'10px'} mt={'4px'} color={'danger.500'}>
                {errors.code}
            </Text>
        </Box>
    );
}

export const tableData = [
    {
        id: '1',
        bundleName: <BundleNameCell />,
        code: <CodeCell />,
    },
];

export const tableHeadLists = [
    {
        key: 'bundleName',
        title: 'Nama Bundle',
        width: '70%',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        // width: '120px !important',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
];

function ActionHead({ allValue }) {
    const { removeItem, setIsEditingRow } = useBundleStore();

    const handleDelete = () => {
        removeItem(allValue.id);
    };

    const handleEdit = () => {
        setIsEditingRow(allValue);
    };

    return (
        <Popover placement="bottom-end">
            <PopoverTrigger>
                <Button variant={'unstyled'} justifySelf={'end'} px={0} minW={'10px'}>
                    <MoreIcon />
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverBody w={'full'} _hover={{ bg: 'sagitarius.100' }}>
                    <Button
                        variant={'unstyled'}
                        onClick={handleEdit}
                        color={'sagitarius.500'}
                        w={'full'}
                        justifyContent={'start'}
                    >
                        <EditIcon2 size={18} />
                        Edit
                    </Button>
                </PopoverBody>
                <PopoverBody _hover={{ bg: 'danger.100' }}>
                    <Button variant={'unstyled'} onClick={handleDelete} color={'danger.500'}>
                        <TrashcanIcon size={18} />
                        Delete
                    </Button>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export const tableHeadListsAddProduct = [
    {
        key: 'brand',
        title: 'Brand',
        width: '120px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'name',
        title: 'Produk Paragon',
        width: '320px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'barcode',
        title: 'Kode Produk Paragon',
        // width: '120px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '30px',
        // align: 'right',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
